import translate from '../functions/translate';
import H2 from './h2';
import H6 from './h6';

interface StepHeaderProps {
    currentStep: number
    numSteps: number
    stepTitle: string
}

const StepHeader = (props: StepHeaderProps) => {
    const {currentStep, numSteps, stepTitle} = props;
    return <>
        <legend>
            <H6>{`${translate('Step')} ${currentStep} ${translate('of')} ${numSteps}`}</H6>
            <H2 style={{marginTop: 0}}>{stepTitle}</H2>
        </legend>
    </>;
};

export default StepHeader;